document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.product__description__content');
  if (!container) return;

  const section = container.querySelector('section.nweb');

  if (section) {
    const divs = section.querySelectorAll('[data-titulo]');
    if (!divs.length) return;

    container.innerHTML = '';

    divs.forEach((div, index) => {
      const titulo = div.getAttribute('data-titulo');
      const tituloFinal = titulo === 'Bullets' ? 'Características' : titulo;
      const h3 = div.querySelector('h3');
      if (h3) h3.remove();

      const details = document.createElement('details');
      details.className = 'pd-acc__item';
      if (index === 0) details.setAttribute('open', '');

      details.innerHTML = `
        <summary class="pd-acc__summary">
          <span class="pd-acc__summary-text">${tituloFinal}</span>
          <span class="pd-acc__arrow" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-nav-arrow-down" viewBox="0 0 24 24">
              <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            </svg>
          </span>
        </summary>
        <div class="pd-acc__content-wrap">
          <div class="pd-acc__content rte">${div.innerHTML}</div>
        </div>
      `;
      container.appendChild(details);
    });

  } else {
    const rawContent = container.innerHTML;
    container.innerHTML = '';

    const details = document.createElement('details');
    details.className = 'pd-acc__item';
    details.setAttribute('open', '');

    details.innerHTML = `
      <summary class="pd-acc__summary">
        <span class="pd-acc__summary-text">Descripción</span>
        <span class="pd-acc__arrow" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-nav-arrow-down" viewBox="0 0 24 24">
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
        </span>
      </summary>
      <div class="pd-acc__content-wrap">
        <div class="pd-acc__content rte">${rawContent}</div>
      </div>
    `;
    container.appendChild(details);
  }

  container.querySelectorAll('.pd-acc__item').forEach((det, index) => {
    const wrap = det.querySelector('.pd-acc__content-wrap');
    wrap.style.height = det.open ? 'auto' : '0px';

    det.addEventListener('click', e => {
      e.preventDefault();
      if (det.open) {
        wrap.style.height = wrap.scrollHeight + 'px';
        requestAnimationFrame(() => { wrap.style.height = '0px'; });
        wrap.addEventListener('transitionend', () => {
          det.removeAttribute('open');
        }, { once: true });
      } else {
        det.setAttribute('open', '');
        wrap.style.height = '0px';
        requestAnimationFrame(() => { wrap.style.height = wrap.scrollHeight + 'px'; });
        wrap.addEventListener('transitionend', () => {
          wrap.style.height = 'auto';
        }, { once: true });
      }
    });
  });

  // Asegurar que el primero quede abierto
  const primero = container.querySelector('.pd-acc__item');
  if (primero) {
    const wrap = primero.querySelector('.pd-acc__content-wrap');
    primero.setAttribute('open', '');
    wrap.style.height = 'auto';
  }
});